export default __webpack_public_path__ + "4d1b88c0bdf9cc7081c17b0f4d88a7b9.png";